import { Box } from '@mui/system'
import React from 'react'

import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'

export const VideosTab = () => {
  const {
    state: { videos }
  } = useHouseDetail()

  const handleVideoPlay = (src: string) => {
    webtrack({
      category: 'video',
      action: 'click',
      label: 'play-video',
      location: 'image-gallery',
      values: [{ type: 'url', value: src }]
    })
  }

  const handleVideoStop = (src: string) => {
    webtrack({
      category: 'video',
      action: 'click',
      label: 'stop-video',
      location: 'image-gallery',
      values: [{ type: 'url', value: src }]
    })
  }

  return (
    <Box sx={{ mb: '16px' }}>
      {videos?.map(({ video, thumbnail }) => (
        <video
          onPlay={() => handleVideoPlay(video)}
          onPause={() => handleVideoStop(video)}
          width='100%'
          controls
          key={video}
          poster={thumbnail}>
          <source src={video} type='video/mp4' />
          Ihr Browser unterstützt das Video-Tag nicht.
        </video>
      ))}
    </Box>
  )
}
